import { Department } from '@thro-types/billing';

import { TFunction } from 'i18next';
import * as yup from 'yup';

import { translations } from 'locales/i18n';

export const departmentSettingsValidationSchema = (t: TFunction<'translation', undefined>) =>
  yup.object().shape({
    name: yup.string().required(t(translations.validation.required())).trim(),
    email: yup.string().required(t(translations.validation.required())).trim(),
    phone: yup.string().required(t(translations.validation.required())).trim()
  });

export const useDepartmentSettingsInitialValue = (
  department: Department | undefined
): Partial<Omit<Department, 'id'>> => {
  return department
    ? department
    : {
        name: '',
        email: '',
        phone: ''
      };
};
